import { Formula, Vehicle } from '@otw/models'

/**
 * Finds a matching formula for the given vehicle
 * @param formulas Array of available formulas
 * @param vehicle Vehicle object to match against formulas
 * @returns Matching formula or null if no match found
 */
export const matchFormula = (
  formulas: Formula[],
  vehicle: Vehicle | Pick<Vehicle, 'make' | 'model' | 'type' | 'size' | 'fuel'>
): Formula | null => {
  if (!formulas || !vehicle?.make || !vehicle?.model || !vehicle?.type || !vehicle?.size || !vehicle?.fuel) {
    return null
  }

  return formulas.find(
    f =>
      f?.vehicleMake?.toLowerCase() === vehicle.make?.toLowerCase() &&
      f?.vehicleModel?.toLowerCase() === vehicle.model?.toLowerCase() &&
      f?.vehicleType?.toLowerCase() === vehicle.type?.toLowerCase() &&
      f?.vehicleSize?.toLowerCase() === vehicle.size?.toLowerCase() &&
      f?.vehicleFuel?.toLowerCase() === vehicle.fuel?.toLowerCase()
  ) || null
} 